document.addEventListener('DOMContentLoaded', () => {
	const stickyNav = document.querySelector('#sticky-nav');
	if (!stickyNav) return;
	const stickyNavParent = stickyNav.parentElement;
	const sectionAnchors = stickyNav.children;
	const [navLimitLeft, navLimitRight] = stickyNav.querySelectorAll('.nav-limit');
	for (const anchor of sectionAnchors) {
		if (isOverflowing(anchor, navLimitLeft)|| isOverflowing(anchor, navLimitRight)) {
			anchor.classList.add('faded');
		} else {
			anchor.classList.remove('faded');
		}
	}
	const sections = [];
	for (const anchor of sectionAnchors) {
		const sectionId = anchor.dataset.section;
		const sectionElement = document.getElementById(sectionId);
		if (sectionElement) {
			sections.push(sectionElement);
		}
	}
	const sectionOptions = {
		root: null,
		rootMargin: '0px',
		threshold: 0.2, // If omitted there's a bug when navigating backwards
	};

	let currentActiveSection = null;

	const observerCallback = (entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			const currentSection = entry.target.id;
			if (currentSection === currentActiveSection) return;
			currentActiveSection = currentSection;
			for (const  anchor of sectionAnchors) {
				// Scroll so the current one is in the center
				if (anchor.dataset.section === currentSection) {
					anchor.classList.add('current');
				} else {
					anchor.classList.remove('current');
				}
			}
		});
	};

	const observer = new IntersectionObserver(observerCallback, sectionOptions);

	sections.forEach((section) => {
		observer.observe(section);
	});
	const stickyNavOptions = {
		root: null,
		rootMargin: '10% 0px 0px -50%',
		threshold: 0.01,
	};

	const stickyNavObserverCallback = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				console.log('here');
				stickyNav.dataset.visible = 'true';
			} else {
				console.log('not here');
				stickyNav.dataset.visible = 'false';
			}
		});
	};

	const stickyNavObserver = new IntersectionObserver(stickyNavObserverCallback, stickyNavOptions);
	stickyNavObserver.observe(stickyNavParent);

	// // Check if footer section is visible, set sticky nav visibility to 0
	// const footerSection = document.querySelector('.footer-section');
	// if(footerSection) {
	// 	const footerObserver = new IntersectionObserver((entries) => {
	// 		entries.forEach(entry => {
	// 			if (entry.isIntersecting) {
	// 				stickyNav.dataset.visible = 'false';
	// 				footerObserver.unobserve(entry.target);
	// 			}
	// 		});
	// 	}, {
	// 		threshold: 0.01,
	// 	});
	// 	footerObserver.observe(footerSection);
	// }

	// Event for horizontal scrolling on mobile

	// TODO: Instead of overflowing on the parent, check if its on top of the arrows?
	stickyNav.addEventListener('scroll', (e) => {
		for (const anchor of sectionAnchors) {
			if (isOverflowing(anchor, navLimitLeft) || isOverflowing(anchor, navLimitRight)) {
				anchor.classList.add('faded');
			} else {
				anchor.classList.remove('faded');
			}
		}
	});
});

/**
 * @param {HTMLElement | Element} element
 * @param {HTMLElement | Element | null} otherElement
 */
function isOverflowing(element, otherElement = null) {
	if (!element) {
		console.error("The element doesn't exist in the DOM");
		return false;
	}
	const parent = element.parentElement;
	if (!parent) {
		console.error('The element does not have a parent element.');
		return false;
	}
	// Check if the element's dimensions exceed its parent's dimensions
	const elementRect = element.getBoundingClientRect();
	const parentRect = parent.getBoundingClientRect();
	const isOverflowingLeft = elementRect.left < parentRect.left;
	const isOverflowingRight = elementRect.right > parentRect.right;

	if (otherElement) {
		const otherRect = otherElement.getBoundingClientRect();

		const isOverlapping = !(
			elementRect.right < otherRect.left ||
			elementRect.left > otherRect.right ||
			elementRect.bottom < otherRect.top ||
			elementRect.top > otherRect.bottom
		);
		return isOverflowingLeft || isOverflowingRight || isOverlapping;
	}

	return isOverflowingRight || isOverflowingLeft;
}
